import React, { Component } from "react"
import { Bar } from "react-chartjs-2"
import DataLabels from 'chartjs-plugin-datalabels';
import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import ChartDataLabels from 'chartjs-plugin-datalabels';

const BarChartQtyAndComFuel = props => {

  function numberFormat(number, digit = 2) {
    if (number === null || number === "null" || number === "") return "";
    function isFloat(n) {
      return Number(n) === n && n % 1 !== 0;
    }
    if (isFloat(number))
      return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
        minimumFractionDigits: digit,
      });
    return parseFloat(number).toLocaleString(undefined, {
      minimumFractionDigits: digit,
    });
  }

  const [dataGraph, setDataGraph] = useState({
    labels: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19",],
    datasets: [
      {
        label: "Target",
        backgroundColor: "#B87EFF",
        borderColor: "#B87EFF",
        borderWidth: 1,
        hoverBackgroundColor: "#B87EFF",
        hoverBorderColor: "#B87EFF",
        data: [1666, 180, 944, 736, 240, 1271],
        type: 'line',
        showLine: false,
        pointStyle: 'dash',
        pointRotation: 90,
        pointBorderWidth: 100,
        hoverBorderWidth: 100,
        datalabels: {
          display: false,
          color: '#B87EFF',
          // position:'right',
          // textAlign:'right',
          // align:'start',
        }
      },
      {
        label: "Actual - Target Yearly",
        backgroundColor: "#5061BC",
        borderColor: "#FFFFFF",
        borderWidth: 1,
        hoverBackgroundColor: "#7C90FD",
        hoverBorderColor: "#FFFFFF",
        data: [230, 290, 260, 260, 260, 240, 240, 220, 215, 215, 250, 270, 290, 260, 260, 255, 259, 259, 259],
        type: 'bar',
        color: "#FFFFFF",
        datalabels: {
          color: '#5ED1F6',
        }
      },
    ],
  });

  const [option, setOption] = useState({
    maintainAspectRatio: false,
    plugins: {
      datalabels: {
        align: 'top',
      },
    },
    layout: {
      padding: {
        right: 15
      }
    },
    scales: {
      dataset: [
        {
          barPercentage: 0.4,
        },
      ],
      xAxes: [{
        display: true,
        scaleLabel: {
          display: true,
          fontSize: 14,
          labelString: 'Date',
          fontColor: "#FFFFFF",
          fontStyle: "bold",
        },
        gridLines: {
          display: true,
        },
        ticks: {
          fontColor: "#FFFFFF",
          fontStyle: "bold",
          fontSize: 14,
        },
      }],
      yAxes: [{
        display: true,
        scaleLabel: {
          display: true,
          fontSize: 14,
          labelString: 'MMscf/BBTU',
          fontColor: "#FFFFFF",
          position: 'left',
          fontStyle: "bold",
        },
        gridLines: {
          display: true,
        },
        ticks: {
          fontColor: "#FFFFFF",
          fontStyle: "bold",
          fontSize: 14,
          beginAtZero: true,
          callback: function (label, index, labels) {
            var val = Math.abs(label);
            // if (val >= 1000) {
            //   if (label < 0) {
            //     val = val * -1;
            //   }
            //   val = numberFormat(val / 1000, 1) + " K";
            // } else {
            if (label < 0) {
              val = val * -1;
            }
            val = numberFormat(val, 0);
            // }

            return val;
          },
        },
      }],
    },
    tooltips: {
      enabled: true,
      mode: 'nearest',
      intersect: false,
      titleFontSize: 20,
      bodyFontSize: 18,
      bodyFontStyle:"bold",
      callbacks: {
        label: function (tooltipItem, data) {
          // console.log(tooltipItem);
          // console.log(data);
          // var indice = tooltipItem.index;
          return " " + numberFormat(tooltipItem.yLabel, 0);
        }
      },
    },
    
    legend: {
      labels: {
        generateLabels: chart => chart.data.datasets.map((dataset, i) => ({
          datasetIndex: i,
          text: dataset.label,
          fillStyle: dataset.backgroundColor,
          strokeStyle: dataset.borderColor
        })),
        fontColor: "#FFFFFF",
        fontStyle: "bold",
        fontSize: 14,
      },

    },
    // legendCallback: function (chart) {
    //   console.log(chart);
    //   var text = [];
    //   text.push('<ul class="' + chart.id + '-legend">');
    //   for (var i = 0; i < chart.data.datasets.length; i++) {
    //     text.push('<li><div class="legendValue"><span style="background-color:' + chart.data.datasets[i].backgroundColor + '">&nbsp;&nbsp;&nbsp;&nbsp;</span>');

    //     if (chart.data.datasets[i].label) {
    //       text.push('<span class="label">' + chart.data.datasets[i].label + '</span>');
    //     }

    //     text.push('</div></li><div class="clear"></div>');
    //   }

    //   text.push('</ul>');

    //   return text.join('');
    // },
  });

  useEffect(() => {
    renderGraph();
    // console.log(props);
  }, [props.data, props.date, props.summaryReportPid, props.targetPlan]);

  const renderGraph = () => {

    let dataSort = props.data.sort(function (a, b) {
      return moment(a.REPORT_DATE).toDate() - moment(b.REPORT_DATE).toDate();
    });

    let dataDateTarget = props.targetPlan.sort(function (a, b) {
      return moment(a.DAILYFLOWPLAN_DATE).toDate() - moment(b.DAILYFLOWPLAN_DATE).toDate();
    });

    let dateList = [moment(props.date).locale("en").format("D MMM")];

    for (let index = 0; index < 14; index++) {
      dateList.unshift(
        moment(props.date)
          .add("days", -(index + 1))
          .locale("en")
          .format("D MMM")
      );
    }

    let dataTarget = [];
    // dateList.map(item => {
    //   let resData = dataDateTarget.find(row => {
    //     // console.log(row, item);
    //     if (item == moment(props.date).locale("en").format("D MMM")) {
    //       // console.log(row);
    //       return (
    //         moment(row.DAILYFLOWPLAN_DATE).locale("en").format("D MMM") == item
    //         // &&
    //         // props.summaryReportPid == row.SUMMARYREPORT_PID
    //       );
    //     }
    //     return (
    //       moment(row.DAILYFLOWPLAN_DATE).locale("en").format("D MMM") == item
    //     );
    //   });
    //   if (resData == undefined) {
    //     dataTarget.push(null);
    //   } else {
    //     dataTarget.push(resData?.DAILYFLOWPLAN_DATA);
    //   }
    // });

    let dataGenGraph = [];
    dateList.map(item => {
      let data = dataSort.find(row => {
        // console.log(row, item);
        if (item == moment(props.date).locale("en").format("D MMM")) {
          // console.log(row);
          return (
            moment(row.REPORT_DATE).locale("en").format("D MMM") == item &&
            props.summaryReportPid == row.SUMMARYREPORT_PID
          );
        }
        return (
          moment(row.REPORT_DATE).locale("en").format("D MMM") == item
        );
      });

      let resData = dataDateTarget.find(row => {
        // console.log(row, item);
        if (item == moment(props.date).locale("en").format("D MMM")) {
          // console.log(row);
          return (
            moment(row.DAILYFLOWPLAN_DATE).locale("en").format("D MMM") == item
            // &&
            // props.summaryReportPid == row.SUMMARYREPORT_PID
          );
        }
        return (
          moment(row.DAILYFLOWPLAN_DATE).locale("en").format("D MMM") == item
        );
      });

      // let data = dataSort.find(row => {
      //   // console.log(row, item);
      //   if (item == moment(props.date).locale("en").format("D MMM")) {
      //     // console.log(row);
      //     return (
      //       moment(row.REPORT_DATE).locale("en").format("D MMM") == item &&
      //       props.summaryReportPid == row.SUMMARYREPORT_PID
      //     );
      //   }
      //   return (
      //     moment(row.REPORT_DATE).locale("en").format("D MMM") == item
      //   );
      // });
      // if (data == undefined) {
      //   dataGenGraph.push(null);
      // } else {
      //   dataGenGraph.push(data?.FUEL_ACTUAL);
      // }
      if (data == undefined) {
        dataGenGraph.push(null);
      } else {
        dataGenGraph.push(data?.FUEL_ACTUAL);
      }

      if (resData == undefined) {
        dataTarget.push(null);
      } else {
        dataTarget.push(resData?.DAILYFLOWPLAN_DATA);
      }
    });

    // console.log(dataTarget)

    // console.log(dataGenGraph)
    //ของเดิม
    // let data = props.data.sort(function (a, b) {
    //   return moment(a.REPORT_DATE).toDate() - moment(b.REPORT_DATE).toDate();
    // });

    // let dataList = [...data.map(obj => obj.FUEL_ACTUAL)];// SUM_FUEL


    // let dateList = [
    //   ...data.map(obj =>
    //     moment(obj.REPORT_DATE).locale("en").format("D MMM YYYY")
    //   ),
    // ];
    //ของเดิม

    setDataGraph({
      labels: dateList,
      datasets: [
        {
          label: "Target",
          backgroundColor: "#FF4545",
          borderColor: "#FF4545",
          borderWidth: 3,
          hoverBackgroundColor: "#FF4545",
          hoverBorderColor: "#FF4545",
          data: dataTarget,
          type: 'line',
          showLine: true,
          fill: false,
          tension: 0,
          spanGaps: false,
          pointStyle: 'dash',
          borderDashOffset: 0.5,
          borderDash: [8, 8],
          pointRotation: 50,
          pointBorderWidth: 0.1,
          hoverBorderWidth: 1,
          datalabels: {
            display: false,
            // color: '#F8F3AC',
            // anchor: "start",
            // align: "right",
            // offset: 5,
            // rotation: -25,
            // formatter: function (value, context) {
            //   if (value == 0) {
            //     return "";
            //   }
            //   return numberFormat(value, 2);
            // }
          }

          //ของเดิม
          // pointStyle: 'dash',
          // pointRotation: 90,
          // pointBorderWidth: 35,
          // hoverBorderWidth: 50,
          // color: "#FFFFFF",
          // datalabels: {
          //   color: '#F8F3AC',
          //   anchor: "start",
          //   align: "right",
          //   offset: 15,
          //   rotation: -25,
          //   formatter: function (value, context) {
          //     if (value == 0) {
          //       return "";
          //     }
          //     return numberFormat(value, 2);
          //   }
          // }
        },
        {
          label: "Actual",
          backgroundColor: "#437AD5",
          borderColor: "#FFFFFF",
          borderWidth: 1,
          barPercentage: 0.5,
          hoverBackgroundColor: "#437AD5",
          hoverBorderColor: "#FFFFFF",
          hoverBorderWidth: 2,
          data: dataGenGraph,
          type: 'bar',
          color: "#FFFFFF",
          datalabels: {
            display: false,
            color: '#A9C7F9',
            anchor: "end",
            align: "top",
            offset: 0,
            formatter: function (value, context) {
              if (value == 0) {
                return "";
              }
              return numberFormat(value, 2);
            }
          }
        },
      ],
    });
  };

  return (
    <React.Fragment>
      <Bar data={dataGraph} options={option} plugins={[ChartDataLabels]} />
      {/* height={50} */}
      {/* plugins={[DataLabels]} */}
    </React.Fragment>
  )
};

BarChartQtyAndComFuel.propTypes = {
  t: PropTypes.any,
  data: PropTypes.any,
  date: PropTypes.any,
  summaryReportPid: PropTypes.any,
  targetPlan: PropTypes.any,
};

export default BarChartQtyAndComFuel;


// const option = {
//   scales: {
//     dataset: [
//       {
//         barPercentage: 0.4,
//       },
//     ],
//     xAxes: [{
//       display: true,
//       scaleLabel: {
//         display: true,
//         fontSize: 12,
//         labelString: 'Date',
//         fontColor: "#FFFFFF",
//       },
//       gridLines: {
//         display: true,
//       },
//       ticks: {
//         fontColor: "#FFFFFF", // this here
//       },
//     }],
//     yAxes: [{
//       display: true,
//       scaleLabel: {
//         display: true,
//         fontSize: 12,
//         labelString: 'MMscf / BBTU',
//         fontColor: "#FFFFFF",
//         position: 'left',
//       },
//       gridLines: {
//         display: true,
//       },
//       ticks: {
//         fontColor: "#FFFFFF", // this here
//         // max:0,
//         min: 0,
//       },
//     }],
//   },
//   legend: {
//     labels: {
//       fontColor: "#FFFFFF",
//     }
//   },
//   annotation: {
//     annotations: [
//       {
//         type: "line",
//         mode: "horizontal",
//         scaleID: "y-axis-0",
//         value: 250,
//         borderColor: "red",
//         borderWidth: 0.7,
//         borderDash: [10, 5],
//         // borderDashOffset: 5,
//         label: {
//           backgroundColor: "rgba(0,0,0,0)",
//           fontSize: 12,
//           fontStyle: "bold",
//           fontColor: "rgba(255, 0, 0, 0.6)",
//           position: "right",
//           enabled: true,
//           content: "",
//           yAdjust: 10,
//         }
//       },

//     ],
//   },
